import { SPECIALTY_FETCH_ALL_INIT } from '../constants/specialtyTypes';

export function fetchAllSpecialties() {
  return {
    type: SPECIALTY_FETCH_ALL_INIT,
  };
}
